.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

:host {
  background-color: #ffffff;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  :host {
    display: block;
  }
}

.product-container {
  padding: 20px 30px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e7e6e6;
  background-color: #ffffff;
  margin-bottom: 10px;
}

@media screen and (min-width: 980px) {
  .product-container {
    flex-direction: row;
  }
}

.service-product-card {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: flex-start;
}

.service-product-card__link {
  text-decoration: none;
}

@media screen and (min-width: 980px) {
  .price-cta-container {
    width: 24%;
  }

  :host(:not([dir="rtl"])) .price-cta-container {
    margin-left: 30px;
  }

  :host([dir="rtl"]) .price-cta-container {
    margin-right: 30px;
  }
}

.section_content {
  padding-top: 20px;
}

.sort-label {
  display: none;
}

@media screen and (min-width: 980px) {
  .sort-label {
    margin-bottom: 10px;
    display: inline-block;
    font-size: 0.875rem;
  }

  :host(:not([dir="rtl"])) .sort-label {
    margin-right: 6px;
  }

  :host([dir="rtl"]) .sort-label {
    margin-left: 6px;
  }
}

.service-product-card-name {
  margin: 0;
  color: #626469;
  font-weight: bold;
  padding-top: 18px;
  padding-bottom: 10px;
  word-break: break-word;
}

@media screen and (min-width: 980px) {
  .service-product-card-name {
    padding-top: 10px;
  }
}

.specifications__view-more-wrapper {
  text-align: center;
}